import { adSlotSizes, pubPageAdTargeting } from "@config/ads";
import CompanionAdvertisement from "@elements/Advertisement/CompanionAdvertisement";
import { GoogleAdsSlotFactory } from "@elements/Advertisement/helpers";
import {
  AdTargetingType,
  AdvertisementTypeEnum,
  ArticleAdTargetKeys,
  PageAdTargetValue,
} from "@typings/Ads.d";
import { twMerge } from "tailwind-merge";

type CompanionAdsImuProps = {
  uniqueSectionName?: string;
  rootClassName?: string;
  subRootClassName?: string;
  pageAdTargetType?: PageAdTargetValue;
  index: number;
  gsChannels?: string[];
  articleSlotTarget?: AdTargetingType<ArticleAdTargetKeys, string>[];
  overrideImu2AdSlots?: googletag.GeneralSize;
  applySizeMapping?: boolean;
};

/**
 * BHBasePage
 * Description: The base page component for all BH pages
 * @name - name of section or page
 */

export function CompanionAdsImu1({
  uniqueSectionName,
  rootClassName,
  pageAdTargetType,
  index,
  gsChannels,
  articleSlotTarget,
  applySizeMapping = false,
}: CompanionAdsImuProps) {
  const PubPageAdTarget =
    pageAdTargetType &&
    (pubPageAdTargeting[pageAdTargetType] as AdTargetingType<
      string,
      PageAdTargetValue
    >);
  return (
    <CompanionAdvertisement
      rootClassName={twMerge("block text-center", rootClassName)}
      companionAdUnitProps={{
        type: AdvertisementTypeEnum.IMU1,
        slot: GoogleAdsSlotFactory.imu1(uniqueSectionName),
        id: index === 0 ? "dfp-ad-imu1" : `dfp-ad-imu1-${index}`,
        adSlotSize: adSlotSizes["imu1"],
        pageNumber: index.toString(),
        ...(PubPageAdTarget && { pubAdTargeting: [PubPageAdTarget] }),
        gsChannels,
        articleSlotTarget,
        innerAdUnitClass: "flex justify-center",
        applySizeMapping,
      }}
    />
  );
}

export function CompanionAdsImu1Article({
  uniqueSectionName,
  rootClassName,
  pageAdTargetType,
  index,
  gsChannels,
  articleSlotTarget,
}: CompanionAdsImuProps) {
  const PubPageAdTarget =
    pageAdTargetType &&
    (pubPageAdTargeting[pageAdTargetType] as AdTargetingType<
      string,
      PageAdTargetValue
    >);
  return (
    <CompanionAdvertisement
      rootClassName={twMerge("block text-center", rootClassName)}
      companionAdUnitProps={{
        type: AdvertisementTypeEnum.IMU1ARTICLE,
        slot: GoogleAdsSlotFactory.imu1(uniqueSectionName),
        id: index === 0 ? "dfp-ad-imu1" : `dfp-ad-imu1-${index}`,
        adSlotSize: adSlotSizes["imu1Article"],
        pageNumber: index.toString(),
        ...(PubPageAdTarget && { pubAdTargeting: [PubPageAdTarget] }),
        gsChannels,
        articleSlotTarget,
        innerAdUnitClass: "flex justify-center",
        applySizeMapping: true,
      }}
    />
  );
}

export function CompanionAdsImu2({
  uniqueSectionName,
  pageAdTargetType,
  index,
  gsChannels,
  articleSlotTarget,
  overrideImu2AdSlots,
  rootClassName,
  subRootClassName,
  applySizeMapping = false,
}: CompanionAdsImuProps) {
  const PubPageAdTarget =
    pageAdTargetType &&
    (pubPageAdTargeting[pageAdTargetType] as AdTargetingType<
      string,
      PageAdTargetValue
    >);
  let imu2adSlots = adSlotSizes["imu2"];
  if (overrideImu2AdSlots) {
    imu2adSlots = overrideImu2AdSlots;
  }
  return (
    <div className={twMerge("lg:flex-1", rootClassName)}>
      <CompanionAdvertisement
        rootClassName={twMerge(
          subRootClassName
            ? subRootClassName
            : "flex justify-center lg:sticky lg:top-[130px] !py-0",
        )}
        companionAdUnitProps={{
          type: AdvertisementTypeEnum.IMU2,
          slot: GoogleAdsSlotFactory.imu2(uniqueSectionName),
          id: `dfp-ad-imu2-${index}`,
          adSlotSize: imu2adSlots,
          pageNumber: index.toString(),
          ...(PubPageAdTarget && { pubAdTargeting: [PubPageAdTarget] }),
          gsChannels,
          articleSlotTarget,
          applySizeMapping,
        }}
      />
    </div>
  );
}

export function CompanionAdsMidArticle({
  uniqueSectionName,
  rootClassName,
  pageAdTargetType,
  index,
  gsChannels,
  articleSlotTarget,
}: CompanionAdsImuProps) {
  const PubPageAdTarget =
    pageAdTargetType &&
    (pubPageAdTargeting[pageAdTargetType] as AdTargetingType<
      string,
      PageAdTargetValue
    >);
  return (
    <CompanionAdvertisement
      rootClassName={twMerge("block text-center", rootClassName)}
      companionAdUnitProps={{
        type: AdvertisementTypeEnum.MIDARTICLESPECIAL,
        slot: GoogleAdsSlotFactory.midarticlespecial(uniqueSectionName),
        id: `dfp-ad-midarticlespecial-${index}`,
        adSlotSize: adSlotSizes["midarticlespecial"],
        pageNumber: index.toString(),
        ...(PubPageAdTarget && { pubAdTargeting: [PubPageAdTarget] }),
        gsChannels,
        articleSlotTarget,
        rootClassName: "",
        innerAdUnitClass: "flex justify-center",
        applySizeMapping: true,
      }}
    />
  );
}
